import { render, staticRenderFns } from "./statistics-centent.vue?vue&type=template&id=02e042a2&scoped=true&"
import script from "./statistics-centent.vue?vue&type=script&lang=js&"
export * from "./statistics-centent.vue?vue&type=script&lang=js&"
import style0 from "./statistics-centent.vue?vue&type=style&index=0&id=02e042a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e042a2",
  null
  
)

export default component.exports